import { reactive } from 'vue'

export const teststore = reactive({
  domelements: [],
  targetid: "-1",
})